import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import LabelGroup from 'LuxKit/Label/LabelGroup'
import { tileDesktopLayout } from './constants'

const Container = styled.div`
  grid-area: image;
  display: grid;
  grid-template: 1fr / 1fr;
  min-width: ${rem(64)};
  width: ${rem(64)};
  height: ${rem(64)};

  ${tileDesktopLayout} {
    width: 100%;
    height: 100%;
  }

  position: relative;

  > picture {
    position: absolute;
    inset: 0;
  }
`

const LabelsContainer = styled(LabelGroup)`
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  display: none;
  padding: ${rem(8)};

  ${tileDesktopLayout} {
    display: unset;
    z-index: 2;
  }
`

interface Props {
  imageElement: ReactElement
  label?: ReactElement
}

function CartReviewTileImage({ imageElement, label }: Props) {
  return (
    <Container>
      {imageElement}
      {label && <LabelsContainer>
        {label}
      </LabelsContainer>}
    </Container>
  )
}

export default CartReviewTileImage
